"use client";

import Image from "next/image";
import Link from "next/link";
import styles from "./lpMoov.module.css";

const IMG_LOGO = "/images/logo-flex.png";

export default function MoovLpHeader({ cta = "form" }: { cta?: "form" | "whatsapp" | "none" }) {
    const scrollToForm = () => {
        document.getElementById("formulario-final")?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <header className={styles.header}>
            <div className={`${styles.container} ${styles.headerInner}`}>
                {cta === "none" ? (
                    <Link href="https://flexpro.com.br/" className={styles.logoButton} aria-label="Ir para o site da Flexpro">
                        <Image src={IMG_LOGO} alt="Flexpro" width={140} height={36} className={`${styles.logo} ${styles.logoDark}`} priority />
                    </Link>
                ) : (
                <button
                    type="button"
                    className={styles.logoButton}
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    aria-label="Voltar ao topo"
                >
                    <Image src={IMG_LOGO} alt="Flexpro" width={140} height={36} className={`${styles.logo} ${styles.logoDark}`} priority />
                </button>
                )}
                {cta === "none" ? null : cta === "whatsapp" ? (
                    <a className={styles.headerCta} href="/lpmoov2/obrigado">
                        Agendar no WhatsApp
                    </a>
                ) : (
                    <button type="button" className={styles.headerCta} onClick={scrollToForm}>
                        Falar com especialista
                    </button>
                )}
            </div>
        </header>
    );
}
